import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.9599 9.04998L20.0099 11.07C21.3399 11.6 21.3399 12.46 20.0099 12.99L14.9599 15.01L12.9399 20.06C12.4099 21.32 11.5499 21.32 11.0199 20.06L8.99987 15.01L3.94988 12.99C2.68988 12.46 2.68988 11.6 3.94988 11.07L8.99987 9.04998L11.0199 4C11.5499 2.66 12.4099 2.66 12.9399 4L14.9599 9.04998Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgStar;
